import React, { useState } from 'react'
import MasoryPostCard from '../MasoryPostCard/MasoryPostCard'
import { vectorStylesHome, vectorStylesHome600, vectorStylesHome768 } from './utils'
import './MasoryPost.css'
import { Translate } from '../../../language'
import { useDispatch } from 'react-redux'
import { removeContentSaved } from '../../../actions/userActions'

const MasoryPost = ({

    masoryPost = [],
    type = '',
    linkPath,
    scrollHandler,
    isLoading,
    postHomeCampaign
}) => {
    const dispatch = useDispatch()
    return (
        <>

            {[''].map((data, indexData) => {
                var count = 0
                return (<div key={indexData} onScroll={scrollHandler}
                    className={`masory-post-home scroll-menu ${type}`}>
                    {postHomeCampaign &&


                        <MasoryPostCard dataPost={postHomeCampaign} isHome={true} />
                    }
                    {
                        isLoading && <div>Cargando</div>
                    }
                    {!isLoading && masoryPost.map((post, index) => {


                        const style = {}
                        count = count + 1
                        return (
                            <MasoryPostCard key={index} type={type} index={index} linkPath={linkPath} style={style}
                                dataPost={post} isHome={true}
                                options={[
                                    type === "saved" && {
                                        text: Translate('unSaved', 'es'),
                                        onClick: (e) => {
                                            e.stopPropagation();
                                            dispatch(removeContentSaved(post._idS, index))
                                        }
                                    }
                                ].filter(opt => typeof opt != "boolean")}
                            />
                        )
                    })}
                </div>)
            }
            )}
        </>
    )
}

export default MasoryPost
